export default "__VITE_PUBLIC_ASSET__6e89a95c__"